import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _empty = {};
var _getRegistrationRequest = {};
var _getRegistrationsOfRecipientRequest = {};
var _notifyRequest = {};
var _notifyResponse = {};
var _registration = { lastActive: 'google.protobuf.Timestamp' };
var _registrationRequest = {};
var _registrations = { registrations: '_registration' };
var _sendDataRequest = {};
var _sendDataResponse = {};
var _unregistrationRequest = {};
var _updatePushNotificationStatusRequest = {};
var _updatePushNotificationStatusResponse = {};
function resolveComWixpressPingPushApiPushNotificationsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/quickActions',
                destPath: '/quickActions',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/push-notifications-gateway-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/quickActions',
                destPath: '/quickActions',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/quickActions',
                destPath: '/quickActions',
            },
        ],
        'gapps._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/quickAction',
                destPath: '/quickActions',
            },
        ],
        _: [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/ping/push-notifications',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** This endpoint allows you to register to push notifications */
export function register(payload) {
    var _a = serializer(_registrationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __register(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.Register',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __register.fromReq = fromReq;
    __register.__isAmbassador = true;
    return __register;
}
/** This endpoint returns the registrations for a given userId or aspect recipient */
export function getRegistrations(payload) {
    var _a = serializer(_getRegistrationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registrations, { _registration: _registration }).fromJSON;
    function __getRegistrations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'GET',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.GetRegistrations',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/getRegistrations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                        protoPath: '/getRegistrations',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getRegistrations.fromReq = fromReq;
    __getRegistrations.__isAmbassador = true;
    return __getRegistrations;
}
/** This endpoint returns the registrations for a given recipient */
export function getRegistrationsOfRecipient(payload) {
    var _a = serializer(_getRegistrationsOfRecipientRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registrations, { _registration: _registration }).fromJSON;
    function __getRegistrationsOfRecipient(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'GET',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.GetRegistrationsOfRecipient',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/getRegistrationsOfRecipient',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                        protoPath: '/getRegistrationsOfRecipient',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getRegistrationsOfRecipient.fromReq = fromReq;
    __getRegistrationsOfRecipient.__isAmbassador = true;
    return __getRegistrationsOfRecipient;
}
/** This endpoint marks a given registration as unsubscribed */
export function unregister(payload) {
    var _a = serializer(_unregistrationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __unregister(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.Unregister',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/unregister',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unregister.fromReq = fromReq;
    __unregister.__isAmbassador = true;
    return __unregister;
}
/** This endpoint allows you to send push notification */
export function notify(payload) {
    var _a = serializer(_notifyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_notifyResponse, {}).fromJSON;
    function __notify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.Notify',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/v1/push-notifications/notify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __notify.fromReq = fromReq;
    __notify.__isAmbassador = true;
    return __notify;
}
/** This endpoint allows you to send data to the mobile app as a silent push notification */
export function sendData(payload) {
    var _a = serializer(_sendDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendDataResponse, {}).fromJSON;
    function __sendData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.SendData',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/v1/push-notifications/send-data',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendData.fromReq = fromReq;
    __sendData.__isAmbassador = true;
    return __sendData;
}
/** This endpoint update when status of push notification has changed */
export function updatePushNotificationStatus(payload) {
    var _a = serializer(_updatePushNotificationStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePushNotificationStatusResponse, {}).fromJSON;
    function __updatePushNotificationStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.push.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.push.api.PushNotificationsService.UpdatePushNotificationStatus',
            url: resolveComWixpressPingPushApiPushNotificationsServiceUrl({
                protoPath: '/v1/update-status',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePushNotificationStatus.fromReq = fromReq;
    __updatePushNotificationStatus.__isAmbassador = true;
    return __updatePushNotificationStatus;
}
//# sourceMappingURL=http.impl.js.map